module.exports = __webpack_public_path__ + "static/media/Giao thong.12a65e7f.png";